module.exports = __webpack_public_path__ + "SrivatsanP-f0ab004c.webp";